import { useFrame, useThree } from '@react-three/fiber'
import React from 'react'

interface SceneCompilerProps {
  onReady?: () => void
}

function SceneCompiler({ onReady }: SceneCompilerProps) {
  const { gl, scene, camera } = useThree()
  const compiled = React.useRef(false)
  useFrame(() => {
    if (!compiled.current) {
      gl.compile(scene, camera)
      compiled.current = true
      onReady?.()
    }
  })
  return null
}

export default SceneCompiler
